export default {
  evaluationList: [],

  evaluationFilters: {
    class_id: null,
    subject_id: null,
    date_range: 365,
  },

  evaluationOrderBy: 'number',

  evaluationCriteria: null,

  evaluationSubjectMap: {
    2: '수학',
    3: '사회',
    5: '과학',
  },

  classEvaluationDomains: {},

  selectedClassEvaluationDomainIds: {},
};



// WEBPACK FOOTER //
// ./src/app/evaluations/store/state.js